import React, { PropsWithChildren } from 'react';
import { DragOverlay } from '@dnd-kit/core';

interface Props {
  adjustScale?: boolean;
}

export function SortableOverlay({ children, adjustScale = true }: PropsWithChildren<Props>) {
  return <DragOverlay adjustScale={adjustScale}>{children}</DragOverlay>;
}
